import React from "react";
//import LatestCafeContent from "../../components/contentpreview/LatestCafeContent";
import FeaturedCafeContent from "../../components/contentpreview/FeaturedCafeContent";
import PageHeadingWithImage from "../../components/pageheading/PageHeadingWithImage";
import Button from "../../components/singlecomponents/Button";
import { useTranslation } from "react-i18next";
import NewsSection from "../../components/news/NewsSection";

const CafePage: React.FC = () => {
  const { i18n, t } = useTranslation();

  let opinionCategory = "Opinion";

  // this is a shit fix.
  if (i18n.language === "ar") {
    opinionCategory = "رأي";
  }

  return (
    <div className="main cafe-page">
      <PageHeadingWithImage
        className="ze-cafe"
        title={t("zecafe-pageheading.title")}
        subtitle={t("zecafe-pageheading.subtitle")}
        body={t("zecafe-pageheading.body")}
      >
        <a href="https://t.me/ZeFiHub" target="_blank">
          <Button name={t("button.join-community")} />
        </a>
      </PageHeadingWithImage>
      <div className="container">
        <NewsSection />
        {/* <LatestCafeContent
          title={t("zecafe-titlecard-news.title")}
          linkTitle={t("zecafe-titlecard-news.link-title")}
          category={newsCategory}
          link={`/${i18n.language}/cafe/catalogue`}
        /> */}
        <FeaturedCafeContent
          title={t("zecafe-titlecard-articles.title")}
          linkTitle={t("zecafe-titlecard-articles.link-title")}
          category={opinionCategory}
          link={`/${i18n.language}/cafe/catalogue`}
        />
      </div>
    </div>
  );
};

export default CafePage;
